import {
  FETCH_MONITORING_RECORDS,
  FETCH_MONITORING_SUMMARY,
  FETCH_MONITORING_DETAIL,
  CREATE_MONITORING_RECORD,
  UPDATE_MONITORING_RECORD,
  DELETE_MONITORING_RECORD,
  CLEAR_MONITORING_RECORDS,
  SET_SELECTED_MONITORING_RECORD,
} from './monitoringActions';

const initialState = {
  records: [],
  summary: null,
  selectedRecord: null,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  error: null,
};

export default function monitoringReducer(state = initialState, action) {
  switch (action.type) {
    // ==================== FETCH RECORDS ====================
    case FETCH_MONITORING_RECORDS.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_MONITORING_RECORDS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        records: action.payload,
        error: null,
      };
    case FETCH_MONITORING_RECORDS.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // ==================== FETCH SUMMARY ====================
    case FETCH_MONITORING_SUMMARY.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_MONITORING_SUMMARY.SUCCESS:
      return {
        ...state,
        isLoading: false,
        summary: action.payload,
        error: null,
      };
    case FETCH_MONITORING_SUMMARY.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // ==================== FETCH DETAIL ====================
    case FETCH_MONITORING_DETAIL.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_MONITORING_DETAIL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedRecord: action.payload,
        error: null,
      };
    case FETCH_MONITORING_DETAIL.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // ==================== CREATE RECORD ====================
    case CREATE_MONITORING_RECORD.REQUEST:
      return {
        ...state,
        isCreating: true,
        error: null,
      };
    case CREATE_MONITORING_RECORD.SUCCESS:
      return {
        ...state,
        isCreating: false,
        records: [action.payload, ...state.records],
        error: null,
      };
    case CREATE_MONITORING_RECORD.FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload,
      };

    // ==================== UPDATE RECORD ====================
    case UPDATE_MONITORING_RECORD.REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };
    case UPDATE_MONITORING_RECORD.SUCCESS:
      return {
        ...state,
        isUpdating: false,
        records: state.records.map((record) =>
          record.id === action.payload.id ? action.payload : record
        ),
        selectedRecord: state.selectedRecord?.id === action.payload.id
          ? action.payload
          : state.selectedRecord,
        error: null,
      };
    case UPDATE_MONITORING_RECORD.FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    // ==================== DELETE RECORD ====================
    case DELETE_MONITORING_RECORD.REQUEST:
      return {
        ...state,
        isDeleting: true,
        error: null,
      };
    case DELETE_MONITORING_RECORD.SUCCESS:
      return {
        ...state,
        isDeleting: false,
        records: state.records.filter((record) => record.id !== action.payload.recordId),
        selectedRecord: state.selectedRecord?.id === action.payload.recordId
          ? null
          : state.selectedRecord,
        error: null,
      };
    case DELETE_MONITORING_RECORD.FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload,
      };

    // ==================== UI STATE ====================
    case CLEAR_MONITORING_RECORDS:
      return {
        ...initialState,
      };

    case SET_SELECTED_MONITORING_RECORD:
      return {
        ...state,
        selectedRecord: action.payload,
      };

    default:
      return state;
  }
}
